import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row items-center justify-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "row items-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = {
  key: 1,
  class: "row items-center no-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_SImg = _resolveComponent("SImg")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_s_btn_esia = _resolveComponent("s-btn-esia")!
  const _component_TheChat = _resolveComponent("TheChat")!
  const _component_header_notification = _resolveComponent("header-notification")!
  const _component_header_profile = _resolveComponent("header-profile")!
  const _component_q_no_ssr = _resolveComponent("q-no-ssr")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_service_sidebar = _resolveComponent("service-sidebar")!
  const _component_the_attention_bar = _resolveComponent("the-attention-bar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    class: "main__header",
    style: _normalizeStyle(_ctx.viewAttentionBarHeaderStyle)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_toolbar, {
          class: "main__header--container",
          style: _normalizeStyle(_ctx.viewAttentionBarToolbarStyle)
        }, {
          default: _withCtx(() => [
            (_ctx.isLaptop || _ctx.isMobile || _ctx.isMdScreenSize)
              ? (_openBlock(), _createBlock(_component_s_icon, {
                  key: 0,
                  class: "base-margin-right cursor-pointer",
                  name: _ctx.showMenuSidebar ? 'app:close' : 'app:menu',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenuSidebar = !_ctx.showMenuSidebar))
                }, null, 8, ["name"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.routerMainPageName }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "header_logo",
                    src: `${_ctx.routerInitialPath}${_ctx.REGION_ENVIRONMENT}/images/logo.svg`,
                    alt: "Логотип системы"
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (_ctx.isDesktop && !_ctx.isMdScreenSize && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (link, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                      (link.type === 'external')
                        ? (_openBlock(), _createBlock(_component_s_btn, {
                            key: 0,
                            label: link.title,
                            href: link.to(),
                            fat: "",
                            type: "light",
                            target: "_blank"
                          }, null, 8, ["label", "href"]))
                        : (link.type === 'menu')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_s_btn, {
                                label: link.title,
                                fat: "",
                                type: "light",
                                onClick: _cache[1] || (_cache[1] = (e) => {})
                              }, null, 8, ["label"]),
                              _createVNode(_component_q_menu, {
                                anchor: "bottom left",
                                self: "top left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_list, { style: {"min-width":"200px"} }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.to(), (item, idx) => {
                                        return (_openBlock(), _createBlock(_component_q_item, {
                                          key: idx,
                                          clickable: "",
                                          tag: "a",
                                          href: item.url,
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, { side: "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_SImg, {
                                                  url: item.icon,
                                                  width: "24px",
                                                  height: "24px",
                                                  fit: 'contain'
                                                }, null, 8, ["url"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.label), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["href"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : (_openBlock(), _createBlock(_component_s_btn, {
                              key: 2,
                              label: link.title,
                              to: link.to(),
                              fat: "",
                              type: "light"
                            }, null, 8, ["label", "to"]))
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_space),
            _createVNode(_component_q_no_ssr, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (!_ctx.isAuthenticated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_s_btn_esia, {
                          onClick: _ctx.appStore.showAuthDialog
                        }, null, 8, ["onClick"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_s_icon, {
                          class: "s-mr-xl",
                          name: "app:message",
                          onClick: _ctx.openChat
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_TheChat, { ref: "refChat" }, null, 512),
                        _createVNode(_component_header_notification, { onUpdate: _ctx.changeVisibilityNotificationModal }, null, 8, ["onUpdate"]),
                        _createVNode(_component_header_profile, {
                          "profile-label": _ctx.profileLabel,
                          "current-profile-type": _ctx.organizationType,
                          "link-list": _ctx.linkListProfile,
                          "route-to": _ctx.routeTo
                        }, null, 8, ["profile-label", "current-profile-type", "link-list", "route-to"])
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_service_sidebar, {
          modelValue: _ctx.showServiceSidebar,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showServiceSidebar) = $event))
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.viewAttentionBar)
        ? (_openBlock(), _createBlock(_component_the_attention_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.showMenuSidebar,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showMenuSidebar) = $event)),
        width: 280,
        breakpoint: 0,
        overlay: "",
        class: "s-drawer-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, { style: {"min-width":"100px"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (link, key) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                  (link.type === 'external')
                    ? (_openBlock(), _createBlock(_component_q_item, {
                        key: 0,
                        class: "s-divider--grey",
                        href: link.to(),
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(link.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : (link.type === 'menu')
                      ? (_openBlock(), _createBlock(_component_q_item, {
                          key: 1,
                          class: "s-divider--grey"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, { name: "arrow_right" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_menu, {
                              anchor: "top end",
                              self: "top start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_list, { style: {"min-width":"150px"} }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.to(), (item, idx) => {
                                      return (_openBlock(), _createBlock(_component_q_item, {
                                        key: idx,
                                        clickable: "",
                                        tag: "a",
                                        href: item.url,
                                        target: "_blank"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_SImg, {
                                                url: item.icon,
                                                height: "20px",
                                                width: "20px",
                                                fit: 'contain'
                                              }, null, 8, ["url"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.label), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["href"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_q_item, {
                          key: 2,
                          class: "s-divider--grey",
                          to: link.to()
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style"]))
}